import { take, put, call, all, takeLatest } from 'redux-saga/effects';
// import moment from 'moment';

import {
  // initRolePermissionInfo,

  requestRolePermissionStart,
  requestRolePermissionSuccess,
  requestRolePermissionFail,

  setRolePermissionStart,
  // setRolePermissionSuccess,
  // setRolePermissionFail,

} from '../actions/role-permission';

import { PERMISSIONS_INFO_KEY } from '@root/jnzAuthWrapper/permission-keys';

// import requestManagement from '../service/requestManagement';
// const { method_POST, method_GET } = requestManagement;

// import CONFIG from '@root/config/config.next';
// const url = CONFIG.backendEndpoint;


export function* requestRolePermission({ payload }) {

  /*console.log('[sages] requestRolePermission : ', payload);*/

  //====================================================================================================================

  try {

    let _rolePermission;

    /*console.log("[sages] requestRolePermission : ", { _rolePermission });*/

    // async function getRolePermission() {

    //   _rolePermission = await sessionStorage.getItem(PERMISSIONS_INFO_KEY) || {};
    // }

    // getRolePermission();

    _rolePermission = asyncLocalStorage.getItem(PERMISSIONS_INFO_KEY);

    /*console.log("[sages] requestRolePermission : ", { _rolePermission });*/

    yield put(requestRolePermissionSuccess(_rolePermission));


  } catch (error) {

    console.error("[sages] requestRolePermission Fail : ", error);
    yield put(requestRolePermissionFail(error));
  }

  //====================================================================================================================

}

export function* setRolePermission({ payload }) {

  /*console.log('[sages] setRolePermission : ', payload);*/

  //====================================================================================================================

  try {

    // async function saveRolePermission() {
    //   await sessionStorage.setItem(PERMISSIONS_INFO_KEY, JSON.stringify(payload));
    // }

    // saveRolePermission();

    asyncLocalStorage.getItem(PERMISSIONS_INFO_KEY, JSON.stringify(payload));

    /*console.log("[sages] setRolePermission Success : ");*/

    yield put(requestRolePermissionSuccess(payload));

  } catch (error) {

    console.error("[sages] setRolePermission Fail : ", error);
    yield put(requestRolePermissionFail(error));
  }

  //====================================================================================================================

}

const asyncLocalStorage = {
  setItem: async function (key, value) {
    await null;
    return sessionStorage.setItem(key, value);
  },
  getItem: async function (key) {
    await null;
    return sessionStorage.getItem(key);
  }
};

export function* watchRolePermission() {

  /*console.log('[sages] watchRolePermission : ✅');*/

  yield all([
    takeLatest(requestRolePermissionStart, requestRolePermission),
    takeLatest(setRolePermissionStart, setRolePermission),
  ])
}



